// extracted by mini-css-extract-plugin
module.exports = {"container":"Bookmark__container--13VnL115NM"};